import React from 'react';

import Shift from './Shift';

/**
 * Render groups/shifts
 *
 * @param {array} shifts
 * @param {object} capacity
 * @param {number} selectedShiftId
 * @param {function} selectShiftId
 * @param {function} openShift
 * @param {function} addEmployee
 * @returns {null|React.Component}
 */
export default ({ date, shifts, selectShiftId, selectedShiftId, openShift, addEmployee }) => {
  const shiftItems = shifts.map((shift, i) => {
    return (
      <Shift
        key={shift.id}
        currentDate={date}
        selectedShiftId={selectedShiftId}
        shift={shift}
        color={shift.projectColor}
        openShift={openShift}
        selectShiftId={selectShiftId}
        addEmployee={(employeeId) => {
          addEmployee(employeeId, shift.id);
        }}
      />
    );
  });

  return shiftItems.length ? (
    <div className="daylist__groups">
      <div>
        {shiftItems}
      </div>
    </div>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/components/Grid/Shifts.js